import BaseTrackingView from '../../core/baseTrackingView';
import { getCurrentDataLayer } from '../../../home24-shared/tracking/common/helper';

export default BaseTrackingView.extend({
  initialize: function(options) {
    if (!options) {
      throw new Error('Tracking options are required');
    }

    this.googleResponse = options.googleResponse;
    this.pageType = this._getPageType();
  },

  _getPageType: function() {
    var pageData = getCurrentDataLayer();
    var pageType;

    if (pageData.pageLevel && pageData.pageLevel === 'checkout_login') {
      pageType = 'Checkout';
    } else {
      pageType = pageData.pageType;
    }

    return pageType;
  },

  trackWrongAddressTyped: function() {
    this.push('address_wrong');
  },

  trackAddressCheckShow: function() {
    this.push('address_check');
  },

  trackGoogleAddressSelected: function() {
    this.push('address_accepted');
  },

  trackAddressNewInput: function() {
    this.push('address_new_input');
  },

  trackOldAddressKept: function() {
    this.push('address_old_confirmed');
  },

  push: function(event) {
    if (typeof window.dataLayer === 'undefined') {
      return;
    }

    var dataObj = { event: event };
    var address = this.googleResponse;
    var prevPage = this.pageType;

    if (prevPage) {
      dataObj.prevPage = prevPage;
    }

    if (address) {
      dataObj.address_error = address;
    }

    window.dataLayer.push(dataObj);
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/common/AddressCheckEvents.js
 **/